export const getDocumentInformations = (document: string) => {
  const documentCleaned = document.replaceAll(/[^0-9]/g, "");

  if (documentCleaned.length === 11) {
    return {
      document: documentCleaned,
      type: "individual",
      type_entity: "cpf",
    };
  }

  return {
    document: documentCleaned,
    type: "corporation",
    type_entity: "cnpj",
  };
};
